import React from "react"
import Select from 'react-select';
import theme from '../../../config/theme';

const SelectInput = (props) => {
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            borderRadius: '0',
            boxShadow:  props.shadow === false ? '' : '1px 1px 0px rgba(0, 0, 0, 0.1)',
            border: `1px solid ${theme.colors.base.lightGray}`,
            borderColor: theme.colors.base.lightGray,
            height: '38px',
            minWidth: '250px',
            color: theme.colors.base.darkGray,
            cursor: 'pointer',
            borderRadius: '2px',
            fontSize: '1.2rem'
        }),
        menu: (provided, state) => ({
            ...provided,
            borderRadius: '0',
            boxShadow: '1px 1px 0px rgba(0, 0, 0, 0.1)',
            border: `1px solid ${theme.colors.base.lightGray}`,
        }),
        option: (provided, state) => ({
          padding: '10px',
          cursor: 'pointer',
          color: theme.colors.base.darkGray,
          '&:hover': {
            backgroundColor: theme.colors.base.lightGray
          }
        })
    }

    
    return (
        <Select 
            instanceId={props.instanceId || undefined}
            onChange={props.onChange}
            isSearchable={false}
            value={props.value}
            defaultValue={props.options[0]}
            styles={customStyles}
            options={props.options}/>
    )
}

export default SelectInput;